module.exports = __webpack_public_path__ + "9fc117ced1e78b4348429048d8167b34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/docs.svg
// module id = 745
// module chunks = 0